var _g, _g2, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProofOfAddressCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 73,
    viewBox: "0 0 61 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5934_64566)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 9.30542,
    width: 48.0333,
    height: 61.825,
    rx: 3.77477,
    transform: "rotate(-9.95709 1 9.30542)",
    fill: "#F6F4F4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_5934_64566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5918 8.20934C6.5918 6.12459 8.28182 4.43457 10.3666 4.43457H50.8503C52.9351 4.43457 54.6251 6.12459 54.6251 8.20934V62.4848C54.6251 64.5696 52.9351 66.2596 50.8503 66.2596H10.3666C8.28182 66.2596 6.5918 64.5696 6.5918 62.4848V8.20934Z",
    fill: "#FCFAF9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1094,
    y: 12.1926,
    width: 17.5964,
    height: 6.42029,
    rx: 0.943694,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2715 32.9542C11.2715 32.433 11.694 32.0105 12.2152 32.0105H49.0192C49.5404 32.0105 49.9629 32.433 49.9629 32.9542V46.1659C49.9629 46.6871 49.5404 47.1096 49.0192 47.1096H12.2152C11.694 47.1096 11.2715 46.6871 11.2715 46.1659V32.9542Z",
    fill: "#EBE9E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4121 46.1659C42.4121 45.6447 42.8346 45.2222 43.3558 45.2222H49.018C49.5392 45.2222 49.9617 45.6447 49.9617 46.1659V49.6261C49.9617 50.1473 49.5392 50.5698 49.018 50.5698H43.3558C42.8346 50.5698 42.4121 50.1473 42.4121 49.6261V46.1659Z",
    fill: "#EBE9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9551,
    y: 23.8318,
    width: 17.5964,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.9551,
    y: 26.3481,
    width: 12.268,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6602,
    y: 23.8318,
    width: 5.3476,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4121,
    y: 23.8318,
    width: 7.54955,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.6602,
    y: 26.3481,
    width: 3.77478,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4121,
    y: 26.3481,
    width: 5.66216,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2695,
    y: 55.2881,
    width: 17.5964,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 11.2695,
    y: 57.8047,
    width: 14.1554,
    height: 1.25826,
    rx: 0.629129,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5934_64566",
    x: 0.0228805,
    y: 0.336957,
    width: 60.5834,
    height: 71.7836,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.314565,
    dy: 0.629129
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.943694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5934_64566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5934_64566",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5934_64566",
    x: 5.33354,
    y: 3.17631,
    width: 51.808,
    height: 65.5997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.629129,
    dy: 0.629129
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.943694
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5934_64566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5934_64566",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProofOfAddressCheckLarge);
export default __webpack_public_path__ + "static/media/proof_of_address_check_large.4a58bdc7e8e6df94776d5f44411c745d.svg";
export { ForwardRef as ReactComponent };